/**
 * Shadow of types and enumerations from `roboto.domain.files`
 *
 * Definitions match: packages/roboto/src/roboto/domain/files/record.py
 */

import { AssociationType } from "@/shared/domain/association";

// Maximum file size we render a text-based preview for.
export const MAX_FILE_SIZE_PREVIEW = 50000000;

// Cap above which we skip syntax highlighting; hljs.highlight is synchronous
// and stalls the main thread on multi-MB inputs.
export const MAX_FILE_SIZE_HLJS = 1000000;

export enum FileStatus {
  Available = "available",
  Deleted = "deleted",
  Reserved = "reserved",
}

export enum IngestionStatus {
  NotIngested = "not_ingested",
  PartlyIngested = "partly_ingested",
  Ingested = "ingested",
}

export enum FSType {
  File = "file",
  Directory = "directory",
}

export enum FileStorageType {
  S3Imported = "imported",
  S3Uploaded = "uploaded",
  S3Directory = "directory",
}

type ISO_8601_TIMESTAMP = string;

export interface FileRecord {
  association_id: string;
  association_type?: AssociationType;
  created: ISO_8601_TIMESTAMP;
  created_by: string;
  file_id: string;
  modified: ISO_8601_TIMESTAMP;
  modified_by: string;
  relative_path: string;
  size: number;
  org_id: string;
  uri: string;
  status: FileStatus;
  upload_id: string;
  origination: string;
  device_id: string;
  tags: string[];
  metadata: Record<string, string>;
  description: string | null;
  ingestion_status: IngestionStatus;
  version: number;
  fs_type: FSType;
  name: string;
  parent_id: string | null;
  storage_type: FileStorageType;
}

export interface DirectoryRecord {
  association_id: string;
  name: string;
  relative_path: string;
  created: ISO_8601_TIMESTAMP;
  created_by: string;
  description: string | null;
  directory_id: string;
  fs_type: FSType;
  metadata: Record<string, unknown>;
  modified: ISO_8601_TIMESTAMP;
  modified_by: string;
  org_id: string;
  origination: string;
  parent_id: string | null;
  status: FileStatus;
  storage_type: FileStorageType;
  tags: string[];
  upload_id: string;
}
